import React from 'react';
import MaintenanceMode from "./screens/MaintenanceMode";

const App = () => {
  return (
      <MaintenanceMode />
  );
};

/* Actual real code when not in maintenance
      <Router>
        <div className="min-h-screen bg-gray-100 flex flex-col">
          {isUnderDevelopment && (
              <Alert variant="destructive">
                <AlertCircle className="h-4 w-4" />
                <AlertTitle>Site en développement</AlertTitle>
                <AlertDescription>
                  Ce site web est actuellement en construction. Certaines fonctionnalités peuvent ne pas être disponibles.
                </AlertDescription>
              </Alert>
          )}

          <header className="bg-white shadow-md py-4">
            <div className="container mx-auto flex justify-between items-center">
              <Link to="/">
                <h1 className="text-2xl font-bold">Filawave</h1>
              </Link>
              <nav>
                <ul className="flex space-x-6">
                  <li>
                    <Link to="/" className="hover:text-blue-500">Accueil</Link>
                  </li>
                  <li>
                    <Link to="/contact" className="hover:text-blue-500">Contact</Link>
                  </li>
                </ul>
              </nav>
            </div>
          </header>

          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomeScreen />} />
              <Route path="/contact" element={<ContactUsScreen />} />
              <Route path="/enquiry" element={<EnquiryScreen />} />
            </Routes>
          </main>

          <footer className="bg-gray-800 text-white py-4 mt-auto">
            <div className="container mx-auto text-center">
              &copy; {new Date().getFullYear()} Filawave. Tous droits réservés.
            </div>
          </footer>
        </div>
      </Router>
      */

export default App;

